const analysis = function () {
  fbq('trackCustom', '加入购物车')
}
export { analysis }
